/* global System */
// register component(s) with react habitat

export default { NewsSection: () => System.import('./index') }
